import React from 'react';
import { Route, Routes } from 'react-router-dom';
import LoginPage from '../pages/login';
import Profile from '../pages/ProfileView';
import ManageUser from '../pages/manageuser';
import ManageClient from '../pages/manageclients';
import ManageSite from '../pages/managesites';
import Drawing from '../pages/managesites/drawing';
import Manual from '../pages/managesites/manual';
import ChangeRequest from '../pages/managesites/changeRequest';
import ClientMapPage from  '../pages/client';
import Dashboard from  '../pages/dashboard';
import ClientManual from  '../pages/manuals';
import ClientDrawing from  '../pages/drawings';
import ClientChangeRequest from  '../pages/changerequests';
import ProtectedRoute from '../utlis/protectedRoute';
import DefaultLayout from '../layout/DefaultLayout';
import DrawingDetailTable from '../components/common/categorydetail';
import Verify2FA from '../pages/verify';  
import ForgotPassword from '../pages/forgotpassword';  
import ResetPassword from '../pages/resetpassword'; 

const RoutesConfig = () => (
  <Routes>
    <Route path="/" element={<LoginPage />} />
    <Route path="/forgotpassword" element={<ForgotPassword />} />
    <Route path="/verify" element={<Verify2FA />} /> 
    <Route path="/resetPassword" element={<ResetPassword />} /> 

    <Route element={<ProtectedRoute />}>
      <Route element={<DefaultLayout />}>
        <Route path="/profile" element={<Profile />} />
        <Route path="/manageuser" element={<ManageUser />} />
        <Route path="/manageclients" element={<ManageClient />} />
        <Route path="/managesites/:clientId" element={<ManageSite />} />
        <Route path="/managesites/manual/:siteId" element={<Manual />} />
        <Route path="/managesites/drawing/:siteId" element={<Drawing />} />
        <Route path="/managesites/changeRequest/:siteId" element={<ChangeRequest />} />
        

        <Route path="drawing-detail/:id/:siteId" element={<DrawingDetailTable />} />
        <Route path="/client" element={<ClientMapPage />} />
        <Route path="/dashboard/:siteId" element={<Dashboard />} />
        <Route path="/manuals/:siteId" element={<ClientManual />} />
        <Route path="/drawings/:siteId" element={<ClientDrawing />} />
        <Route path="/changerequests/:siteId" element={<ClientChangeRequest />} />
      </Route>
    </Route>
  </Routes>
);

export default RoutesConfig;
